import React from 'react';
import { IonRow, IonCol,  IonText, IonImg, IonGrid } from '@ionic/react';
import './MenuItemRow.scss';
import './MenuItemRowBirdsEye.scss'
import { formatCurrency, hasPrefixSymbol } from '../helpers/currencyHelpers';
import { baseUrl, cacheBust } from '../helpers/configHelper';
import { RolledUpItem } from '../store/MenuStoreTypes';
import { inlineBrandImage } from '../helpers/menuHelpers';

interface MenuItemDetailsProps {
    productFlags: string[];
    kcal?: number;
    rolledUpItems?: RolledUpItem[] | null;
    backgroundColour?: string;
}

function MenuItemDetails(props: MenuItemDetailsProps) {
    const {
        productFlags,
        kcal,
        rolledUpItems,
        backgroundColour,
    } = props;

    function getMenuItemName(item: RolledUpItem) {
        return inlineBrandImage(item.menuItemName, item.hasBrandImage);
    }

    return (
        <div className="menu-item-details-container rolled-price-split">
            {rolledUpItems && rolledUpItems !== null
                ?
                <div>
                    {rolledUpItems.map((v: RolledUpItem) => {
                        return (
                            <div className="rolled-up-item align-children">
                                <span className="details align-children" dangerouslySetInnerHTML={{__html: getMenuItemName(v)}}></span>
                                {typeof v.calories === 'number' &&
                                    <span className="details calories">
                                        {` (${v.calories ?? 0}kcal)`}
                                    </span>
                                }
                                {v.productFlags.map((v: string) => {
                                    return <IonImg className="product-flag" src={`${baseUrl()}/images/assets/${v}.png`} />
                                })}
                            </div>
                        )
                    })}
                </div>
                :
                <div className={`menu-item-details ${backgroundColour ? 'bg-birds-eye-background' : ''}`} style={{
                    backgroundColor: backgroundColour,
                }}>
                    {productFlags.map((v) => {
                        return <img key={v} style={{ width: 'fit-content', height: '30px' }} className="MenuItemIcon" src={`${baseUrl()}/images/assets/${v}.png`} />
                    })}
                    {
                        typeof kcal === 'number' &&
                        <IonText className="kcal">
                            {`${kcal ?? 0}kcal`}
                        </IonText>
                    }
                </div>
            }
        </div>
    );
}

interface MenuItemRowProps {
    menuItemId: number;
    menuItemImage: string;
    menuItemName: string;
    sku: string;
    menuItemBasePrice: number | null;
    menuItemFromPrice: number | null;
    productFlags: string[];
    kcal?: number;
    inStock: boolean;
    onClick?: (menuItemId: number) => void;
    separatorColour?: string;
    rolledUpItems?: RolledUpItem[] | null;
    hasBrandImage: boolean;
    graphicTreatment: string | null;
    backgroundStyle: string | null;
    description: string | null;
}

const DefaultMenuItemRow: React.FC<MenuItemRowProps> = ({productFlags, kcal, menuItemFromPrice, menuItemBasePrice, onClick, menuItemName, hasBrandImage, inStock, menuItemId, separatorColour, rolledUpItems, sku}) => {
    const price = menuItemFromPrice
        ? formatCurrency(menuItemFromPrice)
        : formatCurrency(menuItemBasePrice);

    function handleClick() {
        if (!inStock || typeof onClick === 'undefined') {
            return;
        }

        onClick(menuItemId);
    }

    function getMenuItemName() {
        return inlineBrandImage(menuItemName, hasBrandImage);
    }

    return <div className={"MenuItemRowOuter " + (!inStock ? "OutOfStock" : "")}>
        <IonRow
            key={menuItemId}
            className="menuItemRow menu-item-row"
            style={{borderBottom: `1px solid ${separatorColour ?? "transparent"}`}}
            onClick={handleClick}>
            {
                rolledUpItems
                    ?
                    <> {/* Menu item image, title and price are kept on their own row, rolledUpItems are put on their own row below */}
                        <IonRow>
                            <IonCol size="3" className="">
                                <IonImg onIonError={(e) => {
                                    console.log(e)
                                }} className=""
                                        src={`${baseUrl()}/images/ProductShots/${sku}_PLP.png?v=${cacheBust()}`}/>
                            </IonCol>
                            <IonCol size="9" className="MenuItemTitleWrapper">
                                <IonGrid>
                                    <IonRow>
                                        <IonText className="menu-item-name">
                                            <span className="align-children"
                                                  dangerouslySetInnerHTML={{__html: getMenuItemName()}}/>
                                        </IonText>
                                    </IonRow>
                                    <IonRow className='price-row'>
                                        <div className='rolled-price-split' />
                                        <div className={`flex flex-col menu-item-price-container ${inStock ? "" : "OutOfStockWrapper"}`}>
                                            <IonText className="menu-item-price rolled-price-split">
                                                {hasPrefixSymbol(price)
                                                    ?
                                                    <>
                                                        {menuItemFromPrice && <span className='price-from'>From </span>}
                                                        <span className="sign">{price[0]}</span>
                                                        {price.substring(1)}
                                                    </>
                                                    :
                                                    price
                                                }
                                            </IonText>
                                            <p className="OutOfStockWarning">Out of stock</p>
                                        </div>
                                    </IonRow>
                                </IonGrid>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <MenuItemDetails productFlags={productFlags} kcal={kcal} rolledUpItems={rolledUpItems}/>
                        </IonRow>
                    </>
                    :
                    <>
                        <IonCol size="3" className="">
                            <IonImg onIonError={(e) => {
                                console.log(e)
                            }} className="" src={`${baseUrl()}/images/ProductShots/${sku}_PLP.png?v=${cacheBust()}`}/>
                        </IonCol>

                        <IonCol size="9" className="MenuItemTitleWrapper">
                            <IonGrid>
                                <IonRow>
                                    <IonText className="menu-item-name">
                                        <span className="align-children"
                                              dangerouslySetInnerHTML={{__html: getMenuItemName()}}></span>
                                    </IonText>
                                </IonRow>
                                    <IonRow className='price-row'>
                                    <MenuItemDetails productFlags={productFlags} kcal={kcal} rolledUpItems={rolledUpItems}/>
                                    <div className={`flex flex-col menu-item-price-container ${inStock ? "" : "OutOfStockWrapper"}`}>
                                        <IonText className="menu-item-price rolled-price-split">
                                            {hasPrefixSymbol(price)
                                                ?
                                                <>
                                                    {menuItemFromPrice && <span className='price-from'>From </span>}
                                                    <span className="sign">{price[0]}</span>
                                                    {price.substring(1)}
                                                </>
                                                :
                                                price
                                            }
                                        </IonText>
                                        <p className="OutOfStockWarning">Out of stock</p>
                                    </div>
                                </IonRow>
                            </IonGrid>
                        </IonCol>
                    </>
            }
        </IonRow>
    </div>
}

enum BirdsEyeStyles { Red = "Red", Orange = "Orange", Purple = "Purple" };

const BirdsEyeBackgroundStyles: { [Key: string]: string } = {
    [BirdsEyeStyles.Red]: "images/assets/BE_kids_lproductBG_MOP.png",
    [BirdsEyeStyles.Orange]: "images/assets/BE_yellowOrange_productBG_MOP.png",
    [BirdsEyeStyles.Purple]: "images/assets/BE_redPurple_productBG_MOP.png"
};

const BirdsEyeBackgroundColours: { [Key: string]: string } = {
    [BirdsEyeStyles.Red]: "#EF4743",
    [BirdsEyeStyles.Orange]: "#F68B1D",
    [BirdsEyeStyles.Purple]: "#C3342E"
};

const BirdsEyeMenuItemRow: React.FC<MenuItemRowProps> = ({backgroundStyle, productFlags, kcal, menuItemFromPrice, menuItemBasePrice, onClick, menuItemName, hasBrandImage, inStock, menuItemId, separatorColour, rolledUpItems, sku, description}) => {
    const price = menuItemFromPrice
        ? formatCurrency(menuItemFromPrice)
        : formatCurrency(menuItemBasePrice);

    const handleClick = () => {
        if (!inStock || typeof onClick === 'undefined') {
            return;
        }
        onClick(menuItemId);
    }

    return (
        <div
            style={{
                backgroundImage: `url(${baseUrl()}/${BirdsEyeBackgroundStyles[backgroundStyle ?? "Red"]})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "bottom"
            }}
            className={"MenuItemRowOuter" + (!inStock ? "OutOfStock" : "")}>
            <IonRow
                key={menuItemId}
                className="menuItemRow menu-item-row menu-item-row-birds-eye"
                onClick={handleClick}
            >
                <IonCol size="3" className="images-col">
                    <IonImg
                        onIonError={(e) => {
                                console.log(e)
                        }}
                        className="menu-item-image"
                        src={`${baseUrl()}/images/ProductShots/${sku}_PLP.png?v=${cacheBust()}`}
                    />
                    <img
                        className="birds-eye-logo"
                        src={`${baseUrl()}/images/assets/BE_ItBetterBe.svg`}
                    />
                </IonCol>

                <IonCol size="9" className="MenuItemTitleWrapper">
                    <IonGrid>
                        <IonRow>
                            <IonText className="menu-item-name">
                                <span className="align-children bg-birds-eye-background"
                                    style={{ backgroundColor: BirdsEyeBackgroundColours[backgroundStyle ?? 'Red'] }}
                                    dangerouslySetInnerHTML={{__html: inlineBrandImage(menuItemName, hasBrandImage)}} />
                            </IonText>
                        </IonRow>
                        {/* Only show a description if there is an image */}
                        {description && description.indexOf("[[") >= 0 &&
                            <IonRow
                                className='menu-item-description bg-birds-eye-background'
                                style={{
                                    backgroundColor: BirdsEyeBackgroundColours[backgroundStyle ?? 'Red'],
                                }}
                            >
                                <img className='' src={`${baseUrl()}/images/assets/${description.replace(/(.*)\[\[(.*)]](.*)/, '$2')}`}></img>
                            </IonRow>
                        }
                        <IonRow className="price-row">
                            <MenuItemDetails productFlags={productFlags} kcal={kcal} rolledUpItems={rolledUpItems} backgroundColour={BirdsEyeBackgroundColours[backgroundStyle ?? 'Red']}/>
                            <div className={`flex flex-col menu-item-price-container ${inStock ? "" : "OutOfStockWrapper"}`}>
                                <IonText className={`menu-item-price rolled-price-split ${backgroundStyle == BirdsEyeStyles.Orange && "price-border"}`}>
                                    {
                                        hasPrefixSymbol(price) ?
                                            <>
                                                {menuItemFromPrice && <span className='price-from'>From </span>}
                                                <span className="sign">{price[0]}</span>
                                                {price.substring(1)}
                                            </>
                                            :
                                            price
                                    }
                                </IonText>
                                <p className="OutOfStockWarning">Out of stock</p>
                            </div>
                        </IonRow>
                    </IonGrid>
                </IonCol>
            </IonRow>
        </div>
    )
}

const MenuItemRow: React.FC<MenuItemRowProps> = (props) => {
    return props.graphicTreatment == "BirdsEye" ? <BirdsEyeMenuItemRow {...props} /> : <DefaultMenuItemRow {...props} />;
};

export default MenuItemRow;
